module.exports = __webpack_public_path__ + "static/media/horse-transparent.ce5b3279.png";